import React from 'react';
import {Helmet} from "react-helmet";

const Index = ({ title, description }) => {
    return (
        <Helmet>
            <meta charSet="utf-8" />
            <title>{title}</title>
            <meta name={description}  />
        </Helmet>
    );
};

export default Index;
